import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["widget", "submitButton"]
  static values = { sitekey: String, enabled: Boolean }

  connect() {
    if (!this.enabledValue) return

    if (window.grecaptcha?.render) {
      this.renderWidget()
    } else {
      this.loadScript()
    }
  }

  loadScript() {
    window.onRecaptchaFormLoad = () => this.renderWidget()

    const script = document.createElement("script")
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaFormLoad"
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  renderWidget() {
    this.widgetId = window.grecaptcha.render(this.widgetTarget, {
      sitekey: this.sitekeyValue,
      size: "invisible",
      callback: () => {
        this.verified = true
        this.element.requestSubmit()
      },
    })
  }

  submit(event) {
    if (this.verified || !this.enabledValue || this.widgetId === undefined) return

    event.preventDefault()

    if (!this.element.checkValidity()) {
      this.element.reportValidity()
      return
    }

    this.submitButtonTarget.disabled = true
    window.grecaptcha.execute(this.widgetId)
  }
}
